import { render, staticRenderFns } from "./Allocation.vue?vue&type=template&id=69aa21d2&scoped=true"
import script from "./Allocation.vue?vue&type=script&lang=js"
export * from "./Allocation.vue?vue&type=script&lang=js"
import style0 from "./Allocation.vue?vue&type=style&index=0&id=69aa21d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa21d2",
  null
  
)

export default component.exports